'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var DEPRECIATED_ICON_SIZES = {
  xxs: 16,
  xs: 24,
  sm: 48,
  md: 64,
  lg: 72,
  xl: 96,
  xxl: 128
};

var ICON_SIZES = exports.ICON_SIZES = _extends({
  small: 16,
  medium: 32,
  large: 48
}, DEPRECIATED_ICON_SIZES);

var CARET_WIDTH = exports.CARET_WIDTH = 11.5;
var CARET_HEIGHT = exports.CARET_HEIGHT = 21.1;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/icon/IconConstants.js
// module id = 54
// module chunks = 177